import PropTypes from 'prop-types';
import React from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import _ from 'lodash';

import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';

import Icon from './Icon';
import BaseModal from '../general/BaseModal';

function ConfirmationModal ({
    confirmButtonText,
    icon,
    message,
    messageValues,
    onCancel,
    onConfirm,
    closeText,
    router,
    title,
    hideClose,
}) {
    const onContinue = () => {
        onConfirm(router);
        ModalActions.close(GlobalModals.CONFIRM);
    };
    const onClose = () => {
        onCancel(router);
        ModalActions.close(GlobalModals.CONFIRM);
    };

    return (
        <BaseModal
            onClose={ onClose }
            onContinue={ onContinue }
            closeText={ closeText }
            continueText={ confirmButtonText }
            className="modal--xs"
            titleText={ title }
            hideClose={ hideClose }
        >
                <section className="confirmation text-center">
                    { icon && <Icon icon={ icon } className="margin-top margin-bottom otrl-xl" /> }
                    { message && <p><FormattedHTMLMessage message={ message } { ...messageValues } /></p> }
                </section>
        </BaseModal>
    );
}


ConfirmationModal.propTypes = {
    message: PropTypes.string.isRequired,
    messageValues: PropTypes.object,
    icon: PropTypes.string,
    title: PropTypes.string,
    confirmButtonText: PropTypes.string,
    closeText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    router: routerShape.isRequired,
    hideClose: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
    messageValues: {},
    icon: '',
    title: 'button.text.confirm',
    confirmButtonText: 'button.text.confirm',
    onCancel: _.noop,
    onConfirm: _.noop,
    hideClose: false,
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/general/ConfirmationModal.js